// extracted by mini-css-extract-plugin
export var auto = "_3k-1";
export var spinner = "_3k-0";